import React from 'react';
import { Button, Tooltip, ButtonProps, useMantineTheme } from '@mantine/core';
import classNames from 'classnames';
import styles from '../Header.module.scss';

interface ResponsiveButtonProps {
  isMobile: boolean;
  isTablet: boolean;
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
}

export const ResponsiveButton: React.FC<ResponsiveButtonProps> = ({
  isMobile,
  isTablet,
  icon,
  label,
  onClick,
  variant = 'subtle',
  color,
  ...props
}) => {
  const theme = useMantineTheme();
  const isDark = theme.colors.dark != null;

  // Standardize button variants based on theme
  let buttonVariant = variant;
  if (variant === 'filled' || variant === 'light') {
    buttonVariant = isDark ? 'light' : 'filled';
  } else {
    buttonVariant = isDark ? 'light' : 'subtle';
  }

  const showLabel = !isMobile && !isTablet;

  return (
    <Tooltip label={label} disabled={showLabel}>
      <Button
        {...(!isMobile && { leftSection: icon })}
        size={isMobile ? 'xs' : isTablet ? 'sm' : 'md'}
        p={!showLabel ? 0 : undefined}
        w={!showLabel ? 32 : undefined}
        style={!showLabel ? { aspectRatio: '1/1' } : undefined}
        onClick={onClick}
        variant={buttonVariant}
        color={color}
        className={classNames(styles.header__button, {
          [styles[`header__button--${buttonVariant}`]]: true,
        })}
        {...props}
      >
        {!showLabel ? icon : label}
      </Button>
    </Tooltip>
  );
};
